import React, { useState, useEffect } from "react";
import { useView } from "src/contexts/ViewContext";
import "./LeftBar.css";
import FullScreenButton from "src/components/UiHeader/FullScreenButton";
import { useConfiguration } from "src/contexts/ConfigurationContext";
import { useLoader } from "src/contexts/LoaderContext";
import { useWindowResize } from "src/hooks/useWindowResize";

export const Mouse = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 3V1C11 0.448 11.448 0 12 0C12.552 0 13 0.448 13 1V3C16.86 3 20 6.14 20 10V16C20 20.411 16.411 24 12 24C7.589 24 4 20.411 4 16V10C4 6.14 7.141 3 11 3ZM6 10H11V5C8.243 5 6 7.243 6 10ZM13 5V10H18C18 7.243 15.757 5 13 5ZM12 22C15.309 22 18 19.309 18 16V12H6V16C6 19.309 8.691 22 12 22Z"
      fill="#50505080"
    ></path>
    <path d="M13 10H18C18 7.243 15.757 5 13 5V10Z" fill="currentColor"></path>
  </svg>
);

export const MouseRotate = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path
      d="M11 3V1C11 0.448 11.448 0 12 0C12.552 0 13 0.448 13 1V3C16.86 3 20 6.14 20 10V16C20 20.411 16.411 24 12 24C7.589 24 4 20.411 4 16V10C4 6.14 7.141 3 11 3ZM6 10H11V5C8.243 5 6 7.243 6 10ZM13 5V10H18C18 7.243 15.757 5 13 5ZM12 22C15.309 22 18 19.309 18 16V12H6V16C6 19.309 8.691 22 12 22Z"
      fill={"#50505080"}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M 11.004959,10 V 5 C 8.2479587,5 6.0049587,7.243 6.0049587,10 Z"
      id="path2"
      fill="currentColor"
    />
  </svg>
);

export const MouseZoom: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path
      d="M13 3V1C13 0.448 12.552 0 12 0C11.448 0 11 0.448 11 1V3C7.14 3 4 6.14 4 10V16C4 20.411 7.589 24 12 24C16.411 24 20 20.411 20 16V10C20 6.14 16.859 3 13 3ZM18 10H13V5C15.757 5 18 7.243 18 10ZM11 5V10H6C6 7.243 8.243 5 11 5ZM12 22C8.691 22 6 19.309 6 16V12H18V16C18 19.309 15.309 22 12 22Z"
      fill={"#50505080"}
    />
    <path d="M11 5H13V10H11V5Z" fill="currentColor" />
  </svg>
);

export const MouseMove: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path
      d="M11 3V1C11 0.448 11.448 0 12 0C12.552 0 13 0.448 13 1V3C16.86 3 20 6.14 20 10V16C20 20.411 16.411 24 12 24C7.589 24 4 20.411 4 16V10C4 6.14 7.141 3 11 3ZM6 10H11V5C8.243 5 6 7.243 6 10ZM13 5V10H18C18 7.243 15.757 5 13 5ZM12 22C15.309 22 18 19.309 18 16V12H6V16C6 19.309 8.691 22 12 22Z"
      fill={"#50505080"}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 10V5C15.757 5 18 7.243 18 10H13Z"
      fill="currentColor"
    />
  </svg>
);

export const IconRuler: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
    <g fill="currentColor" clipPath="url(#a)">
      <path d="M7.112.963a1 1 0 0 0-1-1H1.023a1 1 0 0 0-1 1v21.99a1 1 0 0 0 1 1H23.06a1 1 0 0 0 1-1V17.83a1 1 0 0 0-1-1H8.112a1 1 0 0 1-1-1V.963Zm-2.11.405A.703.703 0 1 1 5 2.774.704.704 0 1 0 5 4.18.704.704 0 0 1 5 5.586h-1.41a.703.703 0 1 0 0 1.405H5A.703.703 0 1 1 5 8.397a.704.704 0 1 0 0 1.405A.704.704 0 0 1 5 11.208h-1.41a.703.703 0 0 0 0 1.406H5A.703.703 0 1 1 5 14.019a.703.703 0 1 0 0 1.405c.388.001.704.316.704.705v.703a1 1 0 0 1-.29.705L3.14 19.823c-.629.633-1.71.188-1.71-.705V2.368a1 1 0 0 1 1-1h2.57Zm2.816 16.868c.388 0 .703.315.703.703a.704.704 0 0 0 1.408 0 .703.703 0 1 1 1.409.002v1.45a.704.704 0 1 0 1.408 0v-1.45a.705.705 0 0 1 1.409-.002.704.704 0 0 0 1.408 0 .703.703 0 1 1 1.408.002v1.45a.704.704 0 1 0 1.409 0v-1.45a.705.705 0 0 1 1.408-.002.704.704 0 0 0 1.409 0c0-.388.314-.703.703-.703h.024c.402 0 .728.326.728.728v2.583a1 1 0 0 1-1 1H4.822c-.89 0-1.337-1.074-.71-1.705l2.296-2.31a1 1 0 0 1 .71-.296h.7Z" />
      <path d="m9.722 11.27-.86 2.576a1 1 0 0 0 1.264 1.266l2.584-.86 10.63-10.61a1 1 0 0 0 0-1.415L21.768.658a1 1 0 0 0-1.413 0L9.722 11.27ZM19.07 3.93l.996.994-6.74 6.727-.996-.994 6.74-6.727Zm-8.615 9.591.498-1.49.38-.38.997.994-.38.38-1.495.496ZM21.061 3.93l-.995-.994.995-.994.996.994-.996.994Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

const LeftBar: React.FC = () => {
  const { isAdmin, setIs3DView, is3DView, toggleOptionsVisibility } = useView();
  const { setIsWhiteSceneLoaderVisible } = useLoader();
  const { configurator } = useConfiguration();
  const [showInstructions, setShowInstructions] = useState(false);
  const [isRulerActive, setIsRulerActive] = useState(false);
  const windowWidth = useWindowResize();

  const handleEnable3D = () => {
    setIs3DView(true);
  };

  const handleEnable2D = () => {
    setIs3DView(false);
  };

  const handleZoomIn = () => {
    configurator.zoomIn();
  };

  const handleZoomOut = () => {
    configurator.zoomOut();
  };

  const handleMakeScreenshot = () => {
    setIsWhiteSceneLoaderVisible(true);
    configurator.makeScreenShot();

    setTimeout(() => {
      setIsWhiteSceneLoaderVisible(false);
    }, 600);
  };

  useEffect(() => {
    const updateRulerState = () => {
      if (is3DView) {
        const rulerType = window.CONF?.house?.ruler?.type;
        setIsRulerActive(rulerType === "ruler");
      } else {
        const dimensionsType = window.CONF?.house?.map2D?.dimensionsType;
        setIsRulerActive(dimensionsType === "full");
      }
    };

    updateRulerState();
  }, [is3DView]);

  const handleToggleRuler = () => {
    const newState = !isRulerActive;
    setIsRulerActive(newState);

    if (is3DView) {
      configurator.setRuler(newState ? "ruler" : "none");
    } else {
      configurator.setDimensionsType(newState ? "full" : "none");
    }
  };

  return (
    <div className="left-bar">
      {!is3DView && (
        <span
          className="left-bar-button active tooltip-wrapper"
          id="icon3D"
          onClick={handleEnable3D}
        >
          <div className="tooltip-text">3D weergave</div>
          <svg
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <mask
              id="path-1-outside-1_2001_17"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="26"
              height="26"
              fill="black"
            >
              <rect fill="white" width="26" height="26" />
              <path d="M2 24H6V25H1V20H2V24ZM25 25H20V24H24V20H25V25ZM6 2H2V6H1V1H6V2ZM25 6H24V2H20V1H25V6Z" />
            </mask>
            <path
              d="M2 24H6V25H1V20H2V24ZM25 25H20V24H24V20H25V25ZM6 2H2V6H1V1H6V2ZM25 6H24V2H20V1H25V6Z"
              fill="currentColor"
            />
            <path
              d="M2 24H1.5V24.5H2V24ZM6 24H6.5V23.5H6V24ZM6 25V25.5H6.5V25H6ZM1 25H0.5V25.5H1V25ZM1 20V19.5H0.5V20H1ZM2 20H2.5V19.5H2V20ZM25 25V25.5H25.5V25H25ZM20 25H19.5V25.5H20V25ZM20 24V23.5H19.5V24H20ZM24 24V24.5H24.5V24H24ZM24 20V19.5H23.5V20H24ZM25 20H25.5V19.5H25V20ZM6 2V2.5H6.5V2H6ZM2 2V1.5H1.5V2H2ZM2 6V6.5H2.5V6H2ZM1 6H0.5V6.5H1V6ZM1 1V0.5H0.5V1H1ZM6 1H6.5V0.5H6V1ZM25 6V6.5H25.5V6H25ZM24 6H23.5V6.5H24V6ZM24 2H24.5V1.5H24V2ZM20 2H19.5V2.5H20V2ZM20 1V0.5H19.5V1H20ZM25 1H25.5V0.5H25V1ZM2 24V24.5H6V24V23.5H2V24ZM6 24H5.5V25H6H6.5V24H6ZM6 25V24.5H1V25V25.5H6V25ZM1 25H1.5V20H1H0.5V25H1ZM1 20V20.5H2V20V19.5H1V20ZM2 20H1.5V24H2H2.5V20H2ZM25 25V24.5H20V25V25.5H25V25ZM20 25H20.5V24H20H19.5V25H20ZM20 24V24.5H24V24V23.5H20V24ZM24 24H24.5V20H24H23.5V24H24ZM24 20V20.5H25V20V19.5H24V20ZM25 20H24.5V25H25H25.5V20H25ZM6 2V1.5H2V2V2.5H6V2ZM2 2H1.5V6H2H2.5V2H2ZM2 6V5.5H1V6V6.5H2V6ZM1 6H1.5V1H1H0.5V6H1ZM1 1V1.5H6V1V0.5H1V1ZM6 1H5.5V2H6H6.5V1H6ZM25 6V5.5H24V6V6.5H25V6ZM24 6H24.5V2H24H23.5V6H24ZM24 2V1.5H20V2V2.5H24V2ZM20 2H20.5V1H20H19.5V2H20ZM20 1V1.5H25V1V0.5H20V1ZM25 1H24.5V6H25H25.5V1H25Z"
              fill="currentColor"
              mask="url(#path-1-outside-1_2001_17)"
            />
            <path
              d="M6.69336 12.2236H7.71191C8.07194 12.2236 8.36816 12.1621 8.60059 12.0391C8.83757 11.9115 9.01302 11.7383 9.12695 11.5195C9.24544 11.2962 9.30469 11.0387 9.30469 10.7471C9.30469 10.46 9.25228 10.2116 9.14746 10.002C9.04264 9.78776 8.88314 9.6237 8.66895 9.50977C8.45931 9.39128 8.19043 9.33203 7.8623 9.33203C7.59798 9.33203 7.35417 9.38444 7.13086 9.48926C6.91211 9.59408 6.73665 9.74447 6.60449 9.94043C6.47689 10.1318 6.41309 10.362 6.41309 10.6309H4.60156C4.60156 10.0931 4.74284 9.62142 5.02539 9.21582C5.3125 8.80566 5.69987 8.48438 6.1875 8.25195C6.67513 8.01953 7.21973 7.90332 7.82129 7.90332C8.47754 7.90332 9.05176 8.0127 9.54395 8.23145C10.0407 8.44564 10.4258 8.76237 10.6992 9.18164C10.9772 9.60091 11.1162 10.1204 11.1162 10.7402C11.1162 11.0365 11.0456 11.3327 10.9043 11.6289C10.7676 11.9206 10.5648 12.1849 10.2959 12.4219C10.0316 12.6543 9.70573 12.8434 9.31836 12.9893C8.93555 13.1305 8.49577 13.2012 7.99902 13.2012H6.69336V12.2236ZM6.69336 13.6182V12.6543H7.99902C8.55957 12.6543 9.04492 12.7204 9.45508 12.8525C9.86979 12.9801 10.2116 13.1624 10.4805 13.3994C10.7493 13.6318 10.9476 13.903 11.0752 14.2129C11.2074 14.5228 11.2734 14.8555 11.2734 15.2109C11.2734 15.6758 11.1868 16.0905 11.0137 16.4551C10.8405 16.8151 10.5967 17.1204 10.2822 17.3711C9.97233 17.6217 9.60775 17.8132 9.18848 17.9453C8.76921 18.0729 8.31576 18.1367 7.82812 18.1367C7.4043 18.1367 6.99186 18.0798 6.59082 17.9658C6.19434 17.8473 5.83659 17.6719 5.51758 17.4395C5.19857 17.2025 4.94564 16.9062 4.75879 16.5508C4.57194 16.1908 4.47852 15.7738 4.47852 15.2998H6.29004C6.29004 15.5732 6.35612 15.8171 6.48828 16.0312C6.625 16.2454 6.81185 16.4141 7.04883 16.5371C7.29036 16.6556 7.56152 16.7148 7.8623 16.7148C8.19499 16.7148 8.47982 16.6556 8.7168 16.5371C8.95833 16.4141 9.1429 16.2409 9.27051 16.0176C9.39811 15.7897 9.46191 15.5186 9.46191 15.2041C9.46191 14.8304 9.39128 14.5273 9.25 14.2949C9.10872 14.0625 8.90592 13.8916 8.6416 13.7822C8.38184 13.6729 8.07194 13.6182 7.71191 13.6182H6.69336ZM15.9219 18H13.7754L13.7891 16.5234H15.9219C16.5007 16.5234 16.986 16.3958 17.3779 16.1406C17.7699 15.8809 18.0661 15.5094 18.2666 15.0264C18.4671 14.5387 18.5674 13.9554 18.5674 13.2764V12.7637C18.5674 12.2396 18.5104 11.777 18.3965 11.376C18.2826 10.9749 18.1139 10.6377 17.8906 10.3643C17.6719 10.0908 17.4007 9.88346 17.0771 9.74219C16.7536 9.60091 16.3822 9.53027 15.9629 9.53027H13.7344V8.04688H15.9629C16.6283 8.04688 17.2344 8.15853 17.7812 8.38184C18.3327 8.60514 18.8089 8.92643 19.21 9.3457C19.6156 9.76042 19.9255 10.2572 20.1396 10.8359C20.3584 11.4147 20.4678 12.0618 20.4678 12.7773V13.2764C20.4678 13.9873 20.3584 14.6344 20.1396 15.2178C19.9255 15.7965 19.6156 16.2933 19.21 16.708C18.8089 17.1227 18.3304 17.4417 17.7744 17.665C17.2184 17.8883 16.6009 18 15.9219 18ZM14.8281 8.04688V18H12.9482V8.04688H14.8281Z"
              fill="currentColor"
            />
          </svg>
        </span>
      )}
      {is3DView && (
        <div
          className="left-bar-button toggle-2d-button tooltip-wrapper"
          onClick={handleEnable2D}
        >
          <div className="tooltip-text">2D weergave</div>
          <svg
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <mask
              id="path-1-outside-1_11_140"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="26"
              height="26"
              fill="black"
            >
              <rect fill="white" width="26" height="26" />
              <path d="M2 24H6V25H1V20H2V24ZM25 25H20V24H24V20H25V25ZM6 2H2V6H1V1H6V2ZM25 6H24V2H20V1H25V6Z" />
            </mask>
            <path
              d="M2 24H6V25H1V20H2V24ZM25 25H20V24H24V20H25V25ZM6 2H2V6H1V1H6V2ZM25 6H24V2H20V1H25V6Z"
              fill="currentColor"
            />
            <path
              d="M2 24H1.5V24.5H2V24ZM6 24H6.5V23.5H6V24ZM6 25V25.5H6.5V25H6ZM1 25H0.5V25.5H1V25ZM1 20V19.5H0.5V20H1ZM2 20H2.5V19.5H2V20ZM25 25V25.5H25.5V25H25ZM20 25H19.5V25.5H20V25ZM20 24V23.5H19.5V24H20ZM24 24V24.5H24.5V24H24ZM24 20V19.5H23.5V20H24ZM25 20H25.5V19.5H25V20ZM6 2V2.5H6.5V2H6ZM2 2V1.5H1.5V2H2ZM2 6V6.5H2.5V6H2ZM1 6H0.5V6.5H1V6ZM1 1V0.5H0.5V1H1ZM6 1H6.5V0.5H6V1ZM25 6V6.5H25.5V6H25ZM24 6H23.5V6.5H24V6ZM24 2H24.5V1.5H24V2ZM20 2H19.5V2.5H20V2ZM20 1V0.5H19.5V1H20ZM25 1H25.5V0.5H25V1ZM2 24V24.5H6V24V23.5H2V24ZM6 24H5.5V25H6H6.5V24H6ZM6 25V24.5H1V25V25.5H6V25ZM1 25H1.5V20H1H0.5V25H1ZM1 20V20.5H2V20V19.5H1V20ZM2 20H1.5V24H2H2.5V20H2ZM25 25V24.5H20V25V25.5H25V25ZM20 25H20.5V24H20H19.5V25H20ZM20 24V24.5H24V24V23.5H20V24ZM24 24H24.5V20H24H23.5V24H24ZM24 20V20.5H25V20V19.5H24V20ZM25 20H24.5V25H25H25.5V20H25ZM6 2V1.5H2V2V2.5H6V2ZM2 2H1.5V6H2H2.5V2H2ZM2 6V5.5H1V6V6.5H2V6ZM1 6H1.5V1H1H0.5V6H1ZM1 1V1.5H6V1V0.5H1V1ZM6 1H5.5V2H6H6.5V1H6ZM25 6V5.5H24V6V6.5H25V6ZM24 6H24.5V2H24H23.5V6H24ZM24 2V1.5H20V2V2.5H24V2ZM20 2H20.5V1H20H19.5V2H20ZM20 1V1.5H25V1V0.5H20V1ZM25 1H24.5V6H25H25.5V1H25Z"
              fill="currentColor"
              mask="url(#path-1-outside-1_11_140)"
            />
            <path
              d="M11.458 16.5781V18H4.71777V16.7832L7.95117 13.29C8.28841 12.9072 8.55501 12.5745 8.75098 12.292C8.94694 12.0094 9.08594 11.7542 9.16797 11.5264C9.25456 11.2939 9.29785 11.0729 9.29785 10.8633C9.29785 10.5579 9.24316 10.2913 9.13379 10.0635C9.02441 9.83105 8.86491 9.65104 8.65527 9.52344C8.4502 9.39583 8.19727 9.33203 7.89648 9.33203C7.5638 9.33203 7.27897 9.40951 7.04199 9.56445C6.80957 9.71484 6.63184 9.92448 6.50879 10.1934C6.3903 10.4622 6.33105 10.7699 6.33105 11.1162H4.51953C4.51953 10.5283 4.65625 9.99284 4.92969 9.50977C5.20312 9.02214 5.59505 8.63249 6.10547 8.34082C6.61589 8.04915 7.22201 7.90332 7.92383 7.90332C8.60742 7.90332 9.1862 8.01725 9.66016 8.24512C10.1341 8.46842 10.4941 8.78743 10.7402 9.20215C10.9863 9.61686 11.1094 10.1113 11.1094 10.6855C11.1094 11.0046 11.057 11.319 10.9521 11.6289C10.8473 11.9388 10.6992 12.2464 10.5078 12.5518C10.321 12.8525 10.0977 13.1579 9.83789 13.4678C9.57812 13.7777 9.28874 14.0944 8.96973 14.418L7.02832 16.5781H11.458ZM15.9219 18H13.7754L13.7891 16.5234H15.9219C16.5007 16.5234 16.986 16.3958 17.3779 16.1406C17.7699 15.8809 18.0661 15.5094 18.2666 15.0264C18.4671 14.5387 18.5674 13.9554 18.5674 13.2764V12.7637C18.5674 12.2396 18.5104 11.777 18.3965 11.376C18.2826 10.9749 18.1139 10.6377 17.8906 10.3643C17.6719 10.0908 17.4007 9.88346 17.0771 9.74219C16.7536 9.60091 16.3822 9.53027 15.9629 9.53027H13.7344V8.04688H15.9629C16.6283 8.04688 17.2344 8.15853 17.7812 8.38184C18.3327 8.60514 18.8089 8.92643 19.21 9.3457C19.6156 9.76042 19.9255 10.2572 20.1396 10.8359C20.3584 11.4147 20.4678 12.0618 20.4678 12.7773V13.2764C20.4678 13.9873 20.3584 14.6344 20.1396 15.2178C19.9255 15.7965 19.6156 16.2933 19.21 16.708C18.8089 17.1227 18.3304 17.4417 17.7744 17.665C17.2184 17.8883 16.6009 18 15.9219 18ZM14.8281 8.04688V18H12.9482V8.04688H14.8281Z"
              fill="currentColor"
            />
          </svg>
        </div>
      )}
      {windowWidth > 768 && is3DView && (
        <>
          <div
            className="left-bar-button tooltip-wrapper"
            id="iconZoomIn"
            onClick={handleZoomIn}
          >
            <div className="tooltip-text">Inzoomen</div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
            >
              <path
                d="M9.81578 5.40784H8.41353V8.91346H4.9079V10.3157H8.41353V13.8213H9.81578V10.3157H13.3214V8.91346H9.81578V5.40784Z"
                fill="currentColor"
              />
              <path
                d="M24 21.4755L16.8719 14.3948C17.732 13.0041 18.2293 11.3665 18.2293 9.61463C18.2293 4.58882 14.1404 0.5 9.11463 0.5C4.08882 0.5 0 4.58878 0 9.61463C0 14.6405 4.08882 18.7293 9.11463 18.7293C10.8679 18.7293 12.5067 18.2312 13.8981 17.3699L21.0256 24.4499L24 21.4755ZM1.40225 9.61463C1.40225 5.36202 4.86203 1.90225 9.11463 1.90225C13.3672 1.90225 16.827 5.36202 16.827 9.61463C16.827 13.8672 13.3672 17.327 9.11463 17.327C4.86203 17.327 1.40225 13.8672 1.40225 9.61463ZM15.0438 16.5313C15.3988 16.2265 15.7302 15.8949 16.0348 15.5397L22.0136 21.4788L21.0223 22.4701L15.0438 16.5313Z"
                fill="currentColor"
              />
            </svg>
          </div>
          <div
            className="left-bar-button tooltip-wrapper"
            id="iconZoomOut"
            onClick={handleZoomOut}
          >
            <div className="tooltip-text">Uitzoomen</div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
            >
              <g clipPath="url(#clip0_780_1175)">
                <path
                  d="M24 21.5196L16.905 14.4245C17.7675 13.0307 18.2661 11.3891 18.2661 9.63306C18.2661 4.59709 14.1691 0.5 9.13306 0.5C4.09704 0.5 0 4.59709 0 9.63306C0 14.669 4.09709 18.7661 9.13306 18.7661C10.8891 18.7661 12.5307 18.2675 13.9246 17.405L21.0196 24.5L24 21.5196ZM1.40509 9.63306C1.40509 5.37186 4.87186 1.90509 9.13306 1.90509C13.3943 1.90509 16.861 5.37186 16.861 9.63306C16.861 13.8943 13.3943 17.361 9.13306 17.361C4.87186 17.361 1.40509 13.8943 1.40509 9.63306ZM16.0655 15.5722L22.013 21.5196L21.0196 22.5129L15.0722 16.5655C15.428 16.2602 15.7602 15.928 16.0655 15.5722Z"
                  fill="currentColor"
                />
                <path
                  d="M4.21527 8.93054H14.0509V10.3356H4.21527V8.93054Z"
                  fill="currentColor"
                />
              </g>
              <defs>
                <clipPath id="clip0_780_1175">
                  <rect
                    width="24"
                    height="24"
                    fill="white"
                    transform="translate(0 0.5)"
                  />
                </clipPath>
              </defs>
            </svg>
          </div>
        </>
      )}
      {is3DView && (
        <div
          className={`left-bar-button tooltip-wrapper ${isRulerActive ? "active" : ""
            }`}
          onClick={handleToggleRuler}
          id="iconRuler"
        >
          <div className="tooltip-text">Afmetingen tonen</div>
          <IconRuler />
        </div>
      )}
      {isAdmin() && (
        <div
          className={"left-bar-button tooltip-wrapper"}
          id={"iconMakeScreenShot"}
          onClick={handleMakeScreenshot}
        >
          <div className="tooltip-text">Screenshot maken</div>
          <svg
            width="800px"
            height="800px"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            stroke="currentColor"
          >
            <ellipse
              id="path3"
              cx="13.987859"
              cy="15.993469"
              rx="1.631152"
              ry="1.6417904"
              fill="currentColor"
            />
            <path d="m 4.8336307,20.639804 c -1.581491,-0.0022 -1.4815402,0.0038 -1.4815402,0.0038 l 0.036725,-17.2928693 17.2435589,0.023625 0.02624,5.285461 -4.71e-4,-0.2748062" />
            <path d="m 7.3716846,20.633653 c 13.0832674,7.26e-4 13.2470934,0.0088 13.2470934,0.0088 l -0.0095,-9.421535 -3.509447,0.01543 -1.307219,-1.8885734 -3.68948,0.015422 -1.274157,1.8981175 -3.47124,0.01322 z" />
          </svg>
        </div>
      )}
      {windowWidth > 768 && <FullScreenButton />}
      <div
        className={"left-bar-button tooltip-wrapper legend"}
        id={"iconMakeScreenShot"}
        onClick={toggleOptionsVisibility}
      >
        <div className="tooltip-text">Legenda weergeven</div>
        <span>i</span>
      </div>
      {is3DView && (
        <>
          <div
            className={`left-bar-button tooltip-wrapper ${showInstructions ? " active-light" : ""
              }`}
            onClick={() => setShowInstructions(!showInstructions)}
            id="iconNavigate"
          >
            <div className="tooltip-text">Toon muis-functies</div>
            <Mouse />
          </div>
          <div
            className={`left-bar-button tooltip-wrapper${showInstructions ? "" : " hide"
              }`}
          >
            <div className="tooltip-text tooltip-nav">Draai</div>
            <MouseRotate />
          </div>
          <div
            className={`left-bar-button tooltip-wrapper${showInstructions ? "" : " hide"
              }`}
          >
            <div className="tooltip-text tooltip-nav">Zoomen</div>
            <MouseZoom />
          </div>
          <div
            className={`left-bar-button tooltip-wrapper${showInstructions ? "" : " hide"
              }`}
          >
            <div className="tooltip-text tooltip-nav">Verplaatsen</div>
            <MouseMove />
          </div>
        </>
      )}
    </div>
  );
};

export default LeftBar;
